import { Box } from '@wix/design-system';
import React from 'react';
export const ProductCardHeader = ({ children, ...props }) => {
    return (React.createElement(Box, { width: "100%", align: "center", ...props }, children));
};
//# sourceMappingURL=ProductCardHeader.js.map